import { ResponseConsent } from "api-client/models/ResponseConsent";

export enum ACTIONS {
    GET_USER_CONSENT_REQUEST = "USER/GET_USER_CONSENT_REQUEST",
    GET_USER_CONSENT_SUCCESS = "USER/GET_USER_CONSENT_SUCCESS",
    GET_USER_CONSENT_FAILURE = "USER/GET_USER_CONSENT_FAILURE",
}

interface GetUserConsentRequest {
    type: ACTIONS.GET_USER_CONSENT_REQUEST;
}

interface GetUserConsentSuccess {
    type: ACTIONS.GET_USER_CONSENT_SUCCESS;
    payload: ResponseConsent[];
}

interface GetUserConsentFailure {
    type: ACTIONS.GET_USER_CONSENT_FAILURE;
}

export type ActionType = GetUserConsentRequest | GetUserConsentSuccess | GetUserConsentFailure;
